import React from 'react';
import { Helmet } from 'react-helmet';
import ManualPayoutsPanel from '@/features/shared/components/ManualPayoutsPanel';

const KaraokePayoutsPage = () => {
  return (
    <>
      <Helmet>
        <title>Payouts — Karaoke</title>
        <meta name="description" content="Request payouts from your karaoke song requests." />
      </Helmet>

      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-purple-100">Payouts</h1>
          <p className="text-purple-300 mt-1 max-w-xl">
            Here’s what you’ve earned from paid requests and what you can ask us to send. Nothing goes out
            automatically — when you’re ready, pop in an amount and we’ll take it from there.
          </p>
        </div>

        <ManualPayoutsPanel payoutSource="karaoke" />
      </div>
    </>
  );
};

export default KaraokePayoutsPage;
